/**
 * Goza Towels — affiliate-first storefront behaviour
 * - Articles: lone "Check price on Amazon" links become buttons; each
 *   "Best X: Product" section that contains an Amazon link is wrapped in a card.
 * - Product pages: strips Amazon-import metadata rows (Release Date, model number…).
 * No dependencies. Loaded deferred from layout/theme.liquid.
 */
(function () {
  'use strict';

  var AMZ = /(^|\.)amazon\.[a-z.]+$|(^|\.)amzn\.to$/i;

  function isAmazonLink(a) {
    try { return AMZ.test(new URL(a.href).hostname); } catch (e) { return false; }
  }

  function hasAmazonLink(el) {
    if (!el || !el.querySelectorAll) return false;
    var links = el.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) if (isAmazonLink(links[i])) return true;
    return false;
  }

  function initArticle() {
    var body = document.querySelector('[data-goza-article]');
    if (!body) return;

    // 0. Every Amazon link in the body is sponsored + nofollow + new tab (inline text links included)
    var all = body.querySelectorAll('a[href]');
    for (var z = 0; z < all.length; z++) {
      if (isAmazonLink(all[z])) {
        all[z].setAttribute('rel', 'nofollow sponsored noopener');
        all[z].setAttribute('target', '_blank');
      }
    }

    // 1. A paragraph whose only content is an Amazon link → button
    var paras = body.querySelectorAll('p');
    for (var i = 0; i < paras.length; i++) {
      var p = paras[i];
      var kids = [];
      for (var k = 0; k < p.childNodes.length; k++) {
        var n = p.childNodes[k];
        if (n.nodeType === 3 && !n.textContent.trim()) continue;
        kids.push(n);
      }
      if (kids.length === 1 && kids[0].tagName === 'A' && isAmazonLink(kids[0])) {
        kids[0].classList.add('Goza-AmazonBtn');
        kids[0].setAttribute('rel', 'nofollow sponsored noopener');
        kids[0].setAttribute('target', '_blank');
        p.classList.add('Goza-AmazonBtnWrap');
      }
    }

    // 2. "Best Overall: Product name" headings → cards
    var heads = body.querySelectorAll('h2');
    for (var h = 0; h < heads.length; h++) {
      var head = heads[h];
      var m = head.textContent.trim().match(/^([^:]{3,40}):\s*(.+)$/);
      if (!m) continue;

      var nodes = [], has = false, sib = head.nextElementSibling;
      while (sib && sib.tagName !== 'H2' && sib.tagName !== 'HR') {
        if (hasAmazonLink(sib)) has = true;
        nodes.push(sib);
        sib = sib.nextElementSibling;
      }
      if (!has) continue;

      var card = document.createElement('div');
      card.className = 'Goza-Pick';
      head.parentNode.insertBefore(card, head);

      var badge = document.createElement('span');
      badge.className = 'Goza-Pick__Badge';
      badge.textContent = m[1];

      head.textContent = m[2];
      head.classList.add('Goza-Pick__Title');

      card.appendChild(badge);
      card.appendChild(head);
      for (var j = 0; j < nodes.length; j++) card.appendChild(nodes[j]);
      if (sib && sib.tagName === 'HR') sib.parentNode.removeChild(sib);
    }
  }

  function initProduct() {
    // Amazon (Spreadr) products render a "View on Amazon" link in place of Add to cart: hide the quantity picker
    var amz = document.querySelector('a.ProductForm__AddToCart[href*="amazon."], a.ProductForm__AddToCart[href*="amzn."]');
    if (amz) document.body.classList.add('Goza-AmazonProduct');

    var junk = /^(release date|model number|item model number|part number|ean|upc|asin|package dimensions)$/i;
    var labels = document.querySelectorAll('.ProductMeta__Description p > b:first-child, .ProductMeta__Description p > strong:first-child, .Product__Description p > b:first-child, .Product__Description p > strong:first-child');
    for (var i = 0; i < labels.length; i++) {
      var t = labels[i].textContent.trim().replace(/:\s*$/, '');
      if (junk.test(t)) labels[i].parentNode.parentNode.removeChild(labels[i].parentNode);
    }
  }

  function initCollection() {
    var hdr = document.querySelector('.template-collection .PageHeader .SectionHeader');
    if (!hdr || hdr.querySelector('.Goza-CollDisclosure')) return;
    var p = document.createElement('p');
    p.className = 'Goza-CollDisclosure';
    p.textContent = 'Picks link to Amazon. As an Amazon Associate we earn from qualifying purchases — at no extra cost to you.';
    hdr.appendChild(p);
  }

  function run() {
    initArticle();
    if (window.theme && window.theme.pageType === 'collection') initCollection();
    if (window.theme && window.theme.pageType === 'product') initProduct();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
